import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'

import { useParams } from 'react-router-dom'

import { GuildEventsUpcomingCard } from './GuildEventsUpcomingCard'

import { GuildEventsUpcomingScreenQuery } from './__generated__/GuildEventsUpcomingScreenQuery.graphql'

export const GuildEventsUpcomingScreen = () => {
  const params = useParams()

  const data = useLazyLoadQuery<GuildEventsUpcomingScreenQuery>(
    graphql`
      query GuildEventsUpcomingScreenQuery($id: String!) {
        nodeBySlugId(id: $id) {
          __typename

          ... on Guild {
            ...GuildEventsUpcomingCard_guild
          }
        }

        ...GuildEventsUpcomingCard_query
      }
    `,
    { id: params.actorId! }
  )

  if (data.nodeBySlugId?.__typename !== 'Guild') {
    return null
  }

  return <GuildEventsUpcomingCard guild={data.nodeBySlugId} query={data} />
}

export default GuildEventsUpcomingScreen
